module.exports = __webpack_public_path__ + "img/yamaguchi2.4b1d53ee.png";